export default {
      id: "icon-download-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-download",
      toString: function () {
        return this.url;
      }
    }